import hypeTrailMutations from "./mutations.js";
import hypeTrailActions from "./actions.js";
import hypeTrailGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {

    };
  },
  mutations: hypeTrailMutations,
  actions: hypeTrailActions,
  getters: hypeTrailGetters,
};
